import { type ReactNode, useState } from 'react'

import { Collapse, type DefaultElementProps } from '@subaio/components'

import { Item } from './Item'

type Props = DefaultElementProps & {
	/** Disabled interaction with the Row. This overrules whether or not something has content. */
	isDisabled?: boolean

	/** This is the content that will be rendered in the clickable `header`, which is above the `children` */
	renderRow: (props: { isExpanded: boolean; isDisabled: boolean; onClick: (() => void) | undefined }) => ReactNode
}

/** This is a row component intended to be used for the `Budget`. It supplies its own expansion logic and is designed to
 * to allow nested additions of `ItemExpandable` in its `content` prop.
 */
export const ItemExpandable = ({ renderRow, children, isDisabled = false, style, className }: Props) => {
	const [isExpanded, setIsExpanded] = useState(false)

	return (
		<Item style={style} className={className}>
			{renderRow({
				isExpanded,
				onClick: isDisabled ? undefined : () => setIsExpanded(!isExpanded),
				isDisabled,
			})}
			{children && !isDisabled && (
				<Collapse isOpen={isExpanded} fill>
					{children}
				</Collapse>
			)}
		</Item>
	)
}
